import { render, staticRenderFns } from "./URLForm.vue?vue&type=template&id=956eba86&"
import script from "./URLForm.vue?vue&type=script&lang=js&"
export * from "./URLForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports